// Coopers Ridge Interactive Features
(function() {
  'use strict';

  // Initialize all interactive features
  document.addEventListener('DOMContentLoaded', function() {
    initScrollAnimations();
    initMagneticButtons();
    initRippleEffect();
    initTextShimmer();
    initParallaxElements();
  });

  // Custom Cursor
  function initCustomCursor() {
    if (window.innerWidth <= 768) return; // Disable on mobile

    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    document.body.appendChild(cursor);

    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.classList.add('custom-cursor--active');
    });

    document.addEventListener('mouseleave', function() {
      cursor.classList.remove('custom-cursor--active');
    });

    // Animate cursor
    function animateCursor() {
      cursorX += (mouseX - cursorX) * 0.1;
      cursorY += (mouseY - cursorY) * 0.1;
      
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      
      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    // Hover effects
    const hoverElements = document.querySelectorAll('a, button, .discipline-card, .shim-position');
    hoverElements.forEach(element => {
      element.addEventListener('mouseenter', function() {
        cursor.classList.add('custom-cursor--hover');
        element.classList.add('cursor-none');
      });

      element.addEventListener('mouseleave', function() {
        cursor.classList.remove('custom-cursor--hover');
        element.classList.remove('cursor-none');
      });

      element.addEventListener('mousedown', function() {
        cursor.classList.add('custom-cursor--click');
      });

      element.addEventListener('mouseup', function() {
        cursor.classList.remove('custom-cursor--click');
      });
    });
  }

  // Scroll Animations
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, observerOptions);

    // Observe elements with scroll animation classes
    const animatedElements = document.querySelectorAll('.scroll-fade-in, .scroll-slide-left, .scroll-slide-right');
    animatedElements.forEach(element => {
      observer.observe(element);
    });

    // Add scroll animations to existing elements
    const productCards = document.querySelectorAll('.card--product');
    productCards.forEach((card, index) => {
      card.classList.add('scroll-fade-in');
      card.style.transitionDelay = `${index * 0.1}s`;
      observer.observe(card);
    });
  }

  // Magnetic Buttons
  function initMagneticButtons() {
    const magneticButtons = document.querySelectorAll('.button:not(.button--tertiary), .hero-coopersridge__button, .discipline-card__link');
    
    magneticButtons.forEach(button => {
      button.classList.add('magnetic-btn');
      
      button.addEventListener('mousemove', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        const distance = Math.sqrt(x * x + y * y);
        const maxDistance = 50;
        
        if (distance < maxDistance) {
          const strength = (maxDistance - distance) / maxDistance;
          const moveX = x * strength * 0.3;
          const moveY = y * strength * 0.3;
          
          this.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.05)`;
        }
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translate(0px, 0px) scale(1)';
      });
    });
  }

  // Ripple Effect
  function initRippleEffect() {
    const buttons = document.querySelectorAll('.button');
    
    buttons.forEach(button => {
      button.classList.add('button-ripple');
    });
  }

  // Text Shimmer Effect (disabled for discipline showcase)
  function initTextShimmer() {
    const headings = document.querySelectorAll('.hero-coopersridge__heading');
    
    headings.forEach(heading => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('text-shimmer');
            }, 500);
          }
        });
      }, { threshold: 0.5 });
      
      observer.observe(heading);
    });
  }

  // Parallax Elements
  function initParallaxElements() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    
    function updateParallax() {
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(element => {
        const speed = element.dataset.parallax || 0.5;
        const yPos = -(scrolled * speed);
        element.style.transform = `translate3d(0, ${yPos}px, 0)`;
      });
    }
    
    if (parallaxElements.length > 0) {
      window.addEventListener('scroll', throttle(updateParallax, 16));
    }
  }

  // Utility: Throttle function
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  // Enhance shim selector interaction
  const shimInputs = document.querySelectorAll('.shim-position input');
  shimInputs.forEach(input => {
    input.addEventListener('change', function() {
      const position = this.closest('.shim-position');
      
      if (this.checked) {
        // Add selection animation
        position.style.animation = 'selectPulse 0.5s ease';
        
        // Create floating indicator
        const indicator = document.createElement('div');
        indicator.innerHTML = '✓';
        indicator.style.cssText = `
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translateX(-50%);
          color: var(--color-coopersridge-green);
          font-weight: bold;
          font-size: 20px;
          pointer-events: none;
          animation: floatUp 1s ease forwards;
        `;
        position.style.position = 'relative';
        position.appendChild(indicator);
        
        setTimeout(() => {
          indicator.remove();
          position.style.animation = '';
        }, 1000);
      }
    });
  });

  // Add CSS for floating animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes floatUp {
      0% {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
      100% {
        opacity: 0;
        transform: translateX(-50%) translateY(-30px);
      }
    }
  `;
  document.head.appendChild(style);

  // Performance: Reduce animations on low-end devices
  if (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) {
    document.body.classList.add('reduced-animations');
    
    // Add reduced animation styles
    const reducedStyle = document.createElement('style');
    reducedStyle.textContent = `
      .reduced-animations * {
        animation-duration: 0.5s !important;
        transition-duration: 0.2s !important;
      }
      .reduced-animations .custom-cursor {
        display: none !important;
      }
    `;
    document.head.appendChild(reducedStyle);
  }

})();